import { SxProps, Theme } from '@mui/material';

import { assetUrl } from '../../../helpers/assetUrl';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      display: 'block',
      height: '128px',
      '& .uppy-Root': {
        height: '100%',
      },
      '& .uppy-Container': {
        height: '100%',
      },
      '& .uppy-DragDrop-container': {
        height: '100%',
        fontFamily: theme.typography.fontFamily,
        outline: 'none',
        boxShadow: 'none !important',
        '&:before': {
          display: 'block',
          content: '""',
          width: '30px',
          height: '35px',
          marginRight: '16px',
          background: `url(${assetUrl('/images/bgs/file-upload.svg')})`,
          backgroundPosition: '50% 50%',
          backgroundRepeat: 'no-repeat',
        },
      },
      '& .uppy-DragDrop-inner': {
        padding: 0,
        lineHeight: 1.28,
        textAlign: 'left',
        '& svg': {
          display: 'none',
        },
        '& .uppy-DragDrop-label': {
          margin: 0,
          color: '#737B7D',
          fontSize: '1.6rem',
          '& .uppy-DragDrop-browse': {
            color: '#0f7895',
            textDecoration: 'underline',
            '&:hover': {
              textDecoration: 'none',
            },
          },
        },
        '& .uppy-DragDrop-note': {
          fontSize: '1.4rem',
          color: theme.palette.error.dark,
        },
      },
      '& .uppy-DragDrop--isDragDropSupported': {
        background: '#f8f9f9',
        border: '1px dashed #b9bdbe',
        borderRadius: 0,
      },
      '.secondaryLevel & .uppy-DragDrop--isDragDropSupported': {
        background: '#fff',
      },
      '&.disabled': {
        opacity: 0.3,
        position: 'relative',

        '&:before': {
          display: 'block',
          content: '""',
          width: '100%',
          height: '100%',
          position: 'absolute',
          background: 'rgba(255,255,255,0)',
          zIndex: 100,
        },
      },
    },
    statusBar: {
      position: 'relative',
      width: '100%',
      '& .uppy-StatusBar': {
        background: 'transparent',
        boxShadow: 'none',
        '& .uppy-StatusBar-progress': {
          background: '#0f7895',
        },
        '& .uppy-StatusBar-text': {
          color: '#0f7895',
          fontSize: '1.4rem',
        },
      },
    },
  };
};
